import { Box, BoxProps, Container } from '@chakra-ui/react';
import React from 'react';

export const CONTAINER_MAX_WIDTH = '8xl';

export const PAGE_CONTENT_PADDING_TOP = 0;

export function PageContentZte({
  maxWidth = CONTAINER_MAX_WIDTH,
  backgroundColor,
  ...rest
}: BoxProps) {
  return (
    <Container
      position="relative"
      zIndex="base"
      paddingTop={PAGE_CONTENT_PADDING_TOP}
      paddingBottom="2"
      maxW="full"
      backgroundColor={backgroundColor}
    >
      <Box marginX="auto" maxWidth={maxWidth} paddingX={0} {...rest} />
    </Container>
  );
}
